<script setup>

import CategoryCard from "~/components/cards/CategoryCard.vue";
import ProductCard from "~/components/cards/ProductCard.vue";

const dairamon = useDairamon();
const categories = await dairamon.storage.getItem('categories');

const { data: products } = await dairamon.products.list({ sort: 'score' });

onMounted(() => {
  console.log(products.value)
});
</script>

<template>

  <div class="webaruhaz page">
    
    <!-- CATEGORY SLIDER -->
    <section class="categories">
      <Slider :data="categories">
        <template #card="data"><CategoryCard :data="data" parent="slider"></CategoryCard></template>
      </Slider>
    </section>
    
    <!-- PRODUCT LIST -->
    <section class="products page">
      <template v-for="(item, index) in products.data">
        <ProductCard v-if="index !== 5" class='product' :data="item"></ProductCard>
      </template>
    </section>
  </div>
  
</template>

<style scoped lang="scss">

.webaruhaz {
  
  .categories {
    margin-bottom: 5rem;
  }
  
  .products {
    // width: 100%;
    margin: auto;
    // padding: 0;
    
    display: grid;
    //grid-template-columns: repeat(var(--product-listing-grid), minmax(0, 1fr));
    grid-template-columns: repeat(auto-fill, minmax(var(--product-card-width), 1fr));
    // grid-template-columns: repeat(auto-fill, minmax(min(var(--product-card-width), 100%), 1fr));
    
    gap: var(--product-card-gap);
    align-items: stretch;
    
  }
  
  .banner {
    width: auto;
    grid-column: 2 span;
    background-color: var(--color2);
    display: grid;
    align-content: center;
    justify-content: center;
    
    p {
      font-size: 3rem;
      
    }
  }
}

</style>
